import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { VehicleProvider } from "@/contexts/VehicleContext";
import { CartProvider } from "@/contexts/CartContext";
import { PricingProvider } from "@/contexts/PricingContext";
import { ContentProvider } from "@/contexts/ContentContext";
import ScrollToTop from "@/components/ScrollToTop";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import NettoyagePage from "@/pages/NettoyagePage";
import MecaniquePage from "@/pages/MecaniquePage";
import TextilePage from "@/pages/TextilePage";
import GaleriePage from "@/pages/GaleriePage";
import AvisPage from "@/pages/AvisPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import SurfacesPage from "@/pages/SurfacesPage";

function App() {
  return (
    <div className="App">
      <VehicleProvider>
        <CartProvider>
          <PricingProvider>
            <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/admin" element={<AdminPage />} />
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/nettoyage" element={<NettoyagePage />} />
                <Route path="/mecanique" element={<MecaniquePage />} />
                <Route path="/textile" element={<TextilePage />} />
                <Route path="/surfaces" element={<SurfacesPage />} />
                <Route path="/galerie" element={<GaleriePage />} />
                <Route path="/avis" element={<AvisPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/reserver" element={<Navigate to="/nettoyage#reserver" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster theme="dark" richColors position="top-center" />
            </ContentProvider>
          </PricingProvider>
        </CartProvider>
      </VehicleProvider>
    </div>
  );
}

export default App;
